import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import axios from 'axios'
import toast from 'react-hot-toast'

import history from '@/router/history'

export interface Res {
  code: 0 | 1
  status?: number
  data: any
  msg: string
}

export interface TaiRes {
  code: 200 | number
  success: boolean
  [key: string]: any
}

const service: AxiosInstance = axios.create({
  baseURL: '',
  withCredentials: true,
  timeout: 12000
})

service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const { headers } = config
    if (headers && localStorage.token) {
      headers['Authorization'] = headers['Authorization'] || localStorage.token
    }
    return config
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (res) => {
    if (res.data.status === 401 || res.data.status === 700 || res.data.status === 702) {
      toast.dismiss()
      toast.error('登录超时，请重新登录！')
      localStorage.clear()
      if (import.meta.env.VITE_APP_ENV === 'dev') {
        history.replace('/login')
      } else {
        history.replace('/student/login')
      }
      return false
    }
    const contentType = res.headers['content-type']
    if (
      contentType.startsWith('application/octet-stream') ||
      contentType.startsWith('application/msexcel') ||
      contentType.startsWith('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    ) {
      return Promise.resolve(res)
    }
    return Promise.resolve(res.data)
  },
  (error) => {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      toast.dismiss()
      toast.error('登录超时，请重新登录！')
      localStorage.clear()
      if (import.meta.env.VITE_APP_ENV === 'dev') {
        history.replace('/login')
      } else {
        history.replace('/student/login')
      }
      return Promise.reject(error.message)
    }
    toast.error(error?.response?.data?.msg || error.message)
    return Promise.reject(error?.response?.data?.msg || error.message)
  }
)

export default service
